// import { useEffect, useState } from 'react'
// import {
//     Box,
//     Button,
//     Checkbox,
//     Chip,
//     Dialog,
//     DialogActions,
//     DialogContent,
//     DialogContentText,
//     DialogTitle,
//     IconButton,
//     LinearProgress,
//     ListItemIcon,
//     Menu,
//     MenuItem,
//     Select,
//     TextField,
//     Tooltip,
//     Typography,
// } from '@mui/material'
// import CloseIcon from '@mui/icons-material/Close'
// import CheckIcon from '@mui/icons-material/Check'
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
// import AddIcon from '@mui/icons-material/Add'
// import ChecklistIcon from '@mui/icons-material/Checklist'
// import AccessTimeIcon from '@mui/icons-material/AccessTime'
// import {
//     PRIMARY,
//     PRIORITIES,
//     STATUSES,
//     STATUS_BY_ID,
//     USERS,
//     USER_BY_ID,
//     formatDueLong,
//     formatDateTime,
//     formatMinutes,
//     formatWhen,
//     loadActivity,
//     type ActivityEntry,
//     type Priority,
//     type StatusId,
//     type TaskPatch,
//     type TodoTask,
// } from './Tododata.ts'
// import UserAvatar from './Useravtar.tsx'

// interface Props {
//     task: TodoTask
//     labelOptions: string[]
//     onClose: () => void
//     /** Saved through the API that matches the changed fields. Resolves true only if it saved, so inputs stay open on failure. */
//     onUpdate: (patch: TaskPatch) => Promise<boolean> | boolean
//     onDelete: () => void
// }

// const ACTIVITY_PREVIEW = 5

// const fieldLabel = { fontSize: 13, color: '#6B6955' } as const
// const sectionTitle = { fontSize: 15, fontWeight: 700 } as const
// const iconBtn = { border: '1px solid #D5D2BF', borderRadius: '8px', width: 36, height: 36 } as const
// const saveBtn = { ...iconBtn, bgcolor: PRIMARY, color: '#fff', borderColor: PRIMARY, '&:hover': { bgcolor: '#5C5A3B' } } as const

// export default function TaskDetailDialog({ task, onClose, onUpdate, onDelete }: Props) {
//     // Title, description and work log each switch to inputs with their own Save button.
//     // Status, assignee, priority, due date and the checklist save as soon as they change.
//     const [editTitle, setEditTitle] = useState(false)
//     const [titleText, setTitleText] = useState('')
//     const [titleError, setTitleError] = useState<string | null>(null)

//     const [editDesc, setEditDesc] = useState(false)
//     const [descText, setDescText] = useState('')

//     const [editLog, setEditLog] = useState(false)
//     const [logTime, setLogTime] = useState('')
//     const [logNote, setLogNote] = useState('')
//     const [logError, setLogError] = useState<string | null>(null)

//     const [newItem, setNewItem] = useState('')
//     const [menuEl, setMenuEl] = useState<HTMLElement | null>(null)
//     const [confirmDelete, setConfirmDelete] = useState(false)

//     const status = STATUS_BY_ID[task.status]
//     const pri = PRIORITIES[task.priority]
//     const checklist = task.checklist
//     const done = checklist.filter((i) => i.isCompleted).length
//     const total = checklist.length

//     // --- title ---------------------------------------------------------------
//     const startTitle = () => {
//         setTitleText(task.title)
//         setTitleError(null)
//         setEditTitle(true)
//     }
//     const saveTitle = async () => {
//         if (!titleText.trim()) return setTitleError('Task title is required')
//         if (titleText.trim() === task.title || (await update({ title: titleText.trim() }))) setEditTitle(false)
//     }

//     // --- description ---------------------------------------------------------
//     const startDesc = () => {
//         setDescText(task.description)
//         setEditDesc(true)
//     }
//     const saveDesc = async () => {
//         if (descText.trim() === task.description || (await update({ description: descText.trim() }))) setEditDesc(false)
//     }

//     // --- work log (one time value + one note) ---------------------------------
//     const startLog = () => {
//         setLogTime(task.timeSpentMinutes ? String(task.timeSpentMinutes) : '')
//         setLogNote(task.completionNote ?? '')
//         setLogError(null)
//         setEditLog(true)
//     }
//     const saveLog = async () => {
//         const n = Number(logTime || 0)
//         if (!Number.isInteger(n) || n < 0 || n > 1440) return setLogError('Enter whole minutes, 0 to 1440')
//         const note = logNote.trim() || null
//         const changed = n !== task.timeSpentMinutes || note !== (task.completionNote ?? null)
//         if (!changed || (await update({ timeSpentMinutes: n, completionNote: note }))) setEditLog(false)
//     }

//     // --- checklist (saved on every change) -----------------------------------
//     const toggleItem = (index: number) =>
//         update({ checklist: checklist.map((i, n) => (n === index ? { ...i, isCompleted: !i.isCompleted } : i)) })
//     const removeItem = (index: number) =>
//         update({ checklist: checklist.filter((_, n) => n !== index).map((c, n) => ({ ...c, displayOrder: n + 1 })) })
//     const addItem = async () => {
//         const text = newItem.trim()
//         if (!text) return
//         if (await update({ checklist: [...checklist, { isActive: true, displayOrder: checklist.length + 1, itemText: text, isCompleted: false }] })) setNewItem('')
//     }

//     // --- activity (read-only, from the activity API) ---------------------------
//     // Loaded when the task opens and again after every successful save, because the server
//     // writes an activity row for each change (checklist edits don't change updatedAt, so we can't rely on that).
//     const [activity, setActivity] = useState<ActivityEntry[]>([])
//     const [activityLoading, setActivityLoading] = useState(true)
//     const [showAll, setShowAll] = useState(false)
//     const [activityTick, setActivityTick] = useState(0)
//     useEffect(() => {
//         let cancelled = false
//         setActivityLoading(true)
//         loadActivity(task.id).then((list) => {
//             if (cancelled) return
//             setActivity(list)
//             setActivityLoading(false)
//         })
//         return () => {
//             cancelled = true
//         }
//     }, [task.id, task.updatedAt, activityTick])

//     /** Save through the parent, then refresh the activity log if it worked. */
//     const update = async (patch: TaskPatch) => {
//         const ok = await onUpdate(patch)
//         if (ok) setActivityTick((t) => t + 1)
//         return ok
//     }
//     const visibleActivity = showAll ? activity : activity.slice(0, ACTIVITY_PREVIEW)

//     return (
//         <Dialog
//             open
//             onClose={onClose}
//             fullWidth
//             maxWidth={false}
//             scroll="paper"
//             aria-labelledby="task-detail-title"
//             PaperProps={{ sx: { width: 1040, maxWidth: '100%', borderRadius: '16px' } }}
//         >
//             {/* Header */}
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 3, py: 1.5, borderBottom: '1px solid #E2DFD0' }}>
//                 <Typography sx={{ fontSize: 13, color: '#6B6955' }}>Team tasks</Typography>
//                 <Typography aria-hidden sx={{ color: '#A09C83' }}>/</Typography>
//                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#55533C' }}>{task.key}</Typography>

//                 <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <IconButton aria-label="More actions" onClick={(e) => setMenuEl(e.currentTarget)} sx={{ border: '1px solid #D5D2BF', borderRadius: '8px' }}>
//                         <MoreHorizIcon fontSize="small" />
//                     </IconButton>
//                     <IconButton aria-label="Close" onClick={onClose}>
//                         <CloseIcon />
//                     </IconButton>
//                 </Box>

//                 <Menu anchorEl={menuEl} open={!!menuEl} onClose={() => setMenuEl(null)}>
//                     <MenuItem
//                         onClick={() => {
//                             setMenuEl(null)
//                             setConfirmDelete(true)
//                         }}
//                         sx={{ color: '#B3402F' }}
//                     >
//                         <ListItemIcon sx={{ color: 'inherit' }}>
//                             <DeleteOutlineIcon fontSize="small" />
//                         </ListItemIcon>
//                         Delete task
//                     </MenuItem>
//                 </Menu>
//             </Box>

//             <DialogContent sx={{ p: 0, display: 'flex', flexWrap: 'wrap' }}>
//                 {/* Left: content */}
//                 <Box sx={{ flex: '999 1 560px', minWidth: 0, p: 3.5, display: 'flex', flexDirection: 'column', gap: 3.5 }}>
//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
//                         {/* Title */}
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
//                             {editTitle ? (
//                                 <>
//                                     <TextField
//                                         fullWidth
//                                         autoFocus
//                                         label="Title"
//                                         value={titleText}
//                                         onChange={(e) => setTitleText(e.target.value)}
//                                         onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), saveTitle())}
//                                         error={!!titleError}
//                                         helperText={titleError}
//                                     />
//                                     <Tooltip title="Save title">
//                                         <IconButton aria-label="Save title" onClick={saveTitle} sx={{ ...saveBtn, mt: 1 }}>
//                                             <CheckIcon fontSize="small" />
//                                         </IconButton>
//                                     </Tooltip>
//                                     <IconButton aria-label="Cancel title edit" onClick={() => setEditTitle(false)} sx={{ ...iconBtn, mt: 1 }}>
//                                         <CloseIcon fontSize="small" />
//                                     </IconButton>
//                                 </>
//                             ) : (
//                                 <>
//                                     <Typography id="task-detail-title" component="h1" sx={{ flex: 1, fontSize: 26, fontWeight: 700, lineHeight: 1.3 }}>
//                                         {task.title}
//                                     </Typography>
//                                     <Tooltip title="Edit title">
//                                         <IconButton aria-label="Edit title" onClick={startTitle} sx={iconBtn}>
//                                             <EditOutlinedIcon fontSize="small" />
//                                         </IconButton>
//                                     </Tooltip>
//                                 </>
//                             )}
//                         </Box>

//                         {/* Description */}
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
//                             {editDesc ? (
//                                 <>
//                                     <TextField
//                                         fullWidth
//                                         autoFocus
//                                         multiline
//                                         minRows={3}
//                                         label="Description (optional)"
//                                         value={descText}
//                                         onChange={(e) => setDescText(e.target.value)}
//                                     />
//                                     <Tooltip title="Save description">
//                                         <IconButton aria-label="Save description" onClick={saveDesc} sx={{ ...saveBtn, mt: 1 }}>
//                                             <CheckIcon fontSize="small" />
//                                         </IconButton>
//                                     </Tooltip>
//                                     <IconButton aria-label="Cancel description edit" onClick={() => setEditDesc(false)} sx={{ ...iconBtn, mt: 1 }}>
//                                         <CloseIcon fontSize="small" />
//                                     </IconButton>
//                                 </>
//                             ) : (
//                                 <>
//                                     <Typography sx={{ flex: 1, fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap', color: task.description ? '#55533C' : '#8A8468' }}>
//                                         {task.description || 'No description'}
//                                     </Typography>
//                                     <Tooltip title="Edit description">
//                                         <IconButton aria-label="Edit description" onClick={startDesc} sx={iconBtn}>
//                                             <EditOutlinedIcon fontSize="small" />
//                                         </IconButton>
//                                     </Tooltip>
//                                 </>
//                             )}
//                         </Box>
//                     </Box>

//                     {/* Checklist */}
//                     <Box component="section" aria-labelledby="chk">
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
//                             <ChecklistIcon sx={{ color: '#55533C' }} fontSize="small" />
//                             <Typography id="chk" component="h2" sx={sectionTitle}>
//                                 Checklist
//                             </Typography>
//                             <Typography sx={{ ml: 'auto', fontSize: 13, fontWeight: 700, color: '#55533C' }}>
//                                 {done}/{total}
//                             </Typography>
//                         </Box>
//                         <LinearProgress
//                             variant="determinate"
//                             value={total ? (done / total) * 100 : 0}
//                             sx={{ height: 6, borderRadius: 3, bgcolor: '#E6E3D3', '& .MuiLinearProgress-bar': { bgcolor: PRIMARY } }}
//                         />
//                         <Box sx={{ mt: 1 }}>
//                             {checklist.length === 0 && <Typography sx={{ py: 1.5, fontSize: 13, color: '#6B6955' }}>No checklist items yet.</Typography>}
//                             {checklist.map((item, index) => (
//                                 <Box key={item.todoChecklistItemId ?? `new-${index}`} sx={{ display: 'flex', alignItems: 'center', gap: 1, minHeight: 44, borderBottom: '1px solid #EEEBDD' }}>
//                                     <Checkbox checked={item.isCompleted} onChange={() => toggleItem(index)} sx={{ '&.Mui-checked': { color: PRIMARY } }} inputProps={{ 'aria-label': item.itemText }} />
//                                     <Typography sx={{ flex: 1, fontSize: 14, color: item.isCompleted ? '#6B6955' : '#25241A', fontWeight: item.isCompleted ? 'bold' : 'normal' }}>
//                                         {item.itemText}
//                                     </Typography>
//                                     <Tooltip title={checklist.length === 1 ? 'A task needs at least one checklist item' : 'Delete item'}>
//                                         <span>
//                                             <IconButton size="small" aria-label={`Delete ${item.itemText}`} onClick={() => removeItem(index)} disabled={checklist.length === 1}>
//                                                 <DeleteOutlineIcon fontSize="small" />
//                                             </IconButton>
//                                         </span>
//                                     </Tooltip>
//                                 </Box>
//                             ))}
//                         </Box>
//                         <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
//                             <TextField
//                                 size="small"
//                                 fullWidth
//                                 placeholder="Add checklist item"
//                                 value={newItem}
//                                 onChange={(e) => setNewItem(e.target.value)}
//                                 onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addItem())}
//                                 inputProps={{ 'aria-label': 'Add checklist item' }}
//                             />
//                             <IconButton aria-label="Add item" onClick={addItem} disabled={!newItem.trim()} sx={{ border: '1px solid #D5D2BF', borderRadius: '8px', width: 40, height: 40 }}>
//                                 <AddIcon fontSize="small" />
//                             </IconButton>
//                         </Box>
//                     </Box>

//                     {/* Work log: one time value and one note */}
//                     <Box component="section" aria-labelledby="wl" sx={{ p: 2.5, border: '1px solid #E2DFD0', borderRadius: '12px', bgcolor: '#FBFAF5' }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.75 }}>
//                             <AccessTimeIcon sx={{ color: '#55533C' }} fontSize="small" />
//                             <Typography id="wl" component="h2" sx={sectionTitle}>
//                                 Work log
//                             </Typography>
//                             <Typography sx={{ ml: 'auto', mr: 0.5, fontSize: 13, fontWeight: 700, color: '#55533C' }}>{formatMinutes(task.timeSpentMinutes)}</Typography>
//                             {editLog ? (
//                                 <>
//                                     <Tooltip title="Save work log">
//                                         <IconButton aria-label="Save work log" onClick={saveLog} sx={saveBtn}>
//                                             <CheckIcon fontSize="small" />
//                                         </IconButton>
//                                     </Tooltip>
//                                     <IconButton aria-label="Cancel work log edit" onClick={() => setEditLog(false)} sx={iconBtn}>
//                                         <CloseIcon fontSize="small" />
//                                     </IconButton>
//                                 </>
//                             ) : (
//                                 <Tooltip title="Edit work log">
//                                     <IconButton aria-label="Edit work log" onClick={startLog} sx={iconBtn}>
//                                         <EditOutlinedIcon fontSize="small" />
//                                     </IconButton>
//                                 </Tooltip>
//                             )}
//                         </Box>
//                         {editLog ? (
//                             <Box sx={{ display: 'flex', alignItems: 'start', flexWrap: 'wrap', gap: 1.5 }}>
//                                 <TextField
//                                     size="small"
//                                     type="number"
//                                     label="Time spent (minutes)"
//                                     value={logTime}
//                                     onChange={(e) => setLogTime(e.target.value)}
//                                     error={!!logError}
//                                     helperText={logError ?? ' '}
//                                     inputProps={{ min: 0, max: 1440, step: 5 }}
//                                     sx={{ width: 190, '& .MuiOutlinedInput-root': { bgcolor: '#fff' } }}
//                                 />
//                                 <TextField
//                                     size="small"
//                                     label="What was done"
//                                     multiline
//                                     minRows={2}
//                                     value={logNote}
//                                     onChange={(e) => setLogNote(e.target.value)}
//                                     sx={{ flex: '1 1 280px', '& .MuiOutlinedInput-root': { bgcolor: '#fff' } }}
//                                 />
//                             </Box>
//                         ) : task.timeSpentMinutes > 0 || task.completionNote ? (
//                             <Typography sx={{ fontSize: 14, color: '#3B3A2A', whiteSpace: 'pre-wrap' }}>
//                                 <b>{formatMinutes(task.timeSpentMinutes)}</b>
//                                 {task.completionNote ? `: ${task.completionNote}` : ''}
//                             </Typography>
//                         ) : (
//                             <Typography sx={{ fontSize: 13, color: '#6B6955' }}>No work logged yet.</Typography>
//                         )}
//                     </Box>

//                     {/* Activity */}
//                     <Box component="section" aria-labelledby="act">
//                         <Typography id="act" component="h2" sx={{ ...sectionTitle, mb: 1.5 }}>
//                             Activity
//                         </Typography>
//                         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                             {activityLoading && activity.length === 0 && <Typography sx={{ fontSize: 13, color: '#6B6955' }}>Loading activity…</Typography>}
//                             {!activityLoading && activity.length === 0 && <Typography sx={{ fontSize: 13, color: '#6B6955' }}>No activity yet.</Typography>}
//                             {visibleActivity.map((a) => (
//                                 <Box key={a.id} sx={{ display: 'flex', gap: 1.5 }}>
//                                     <UserAvatar user={USER_BY_ID[a.userId]} size={32} />
//                                     <Box sx={{ minWidth: 0 }}>
//                                         <Typography sx={{ fontSize: 13 }}>
//                                             <b>{USER_BY_ID[a.userId]?.name ?? 'Someone'}</b>{' '}
//                                             <Box component="span" sx={{ color: '#6B6955' }}>
//                                                 · {formatDateTime(a.createdAt)}
//                                             </Box>
//                                         </Typography>
//                                         <Typography sx={{ mt: 0.5, fontSize: 14, lineHeight: 1.5, color: '#3B3A2A', whiteSpace: 'pre-wrap' }}>{a.text}</Typography>
//                                     </Box>
//                                 </Box>
//                             ))}
//                         </Box>
//                         {activity.length > ACTIVITY_PREVIEW && (
//                             <Button
//                                 size="small"
//                                 onClick={() => setShowAll((v) => !v)}
//                                 sx={{ mt: 1.5, textTransform: 'none', fontWeight: 600, color: PRIMARY }}
//                             >
//                                 {showAll ? 'Show latest 5' : `View all (${activity.length})`}
//                             </Button>
//                         )}
//                     </Box>
//                 </Box>


//                 {/* Right: details (each change is saved straight away) */}
//                 <Box
//                     component="aside"
//                     sx={{ flex: '1 1 300px', maxWidth: { md: 340 }, p: 3, borderLeft: '1px solid #E2DFD0', bgcolor: '#FBFAF5', display: 'flex', flexDirection: 'column', gap: 2.5 }}
//                 >
//                     <Box>
//                         <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: '#5F5D48' }}>Status</Typography>
//                         <Select
//                             fullWidth
//                             size="small"
//                             value={task.status}
//                             onChange={(e) => update({ status: e.target.value as StatusId })}
//                             inputProps={{ 'aria-label': 'Status' }}
//                             sx={{
//                                 bgcolor: status?.pillBg,
//                                 color: status?.ink,
//                                 fontWeight: 700,
//                                 '& .MuiOutlinedInput-notchedOutline': { border: 0 },
//                                 '& .MuiSvgIcon-root': { color: status?.ink },
//                             }}
//                         >
//                             {STATUSES.map((s) => (
//                                 <MenuItem key={s.id} value={s.id}>
//                                     <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: s.dot, mr: 1 }} />
//                                     {s.label}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </Box>

//                     <Box sx={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: 2, alignItems: 'center' }}>
//                         <Typography sx={fieldLabel}>Assignee</Typography>
//                         <Select size="small" value={task.assigneeId} onChange={(e) => update({ assigneeId: e.target.value })} inputProps={{ 'aria-label': 'Assignee' }}>
//                             {USERS.map((u) => (
//                                 <MenuItem key={u.id} value={u.id}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <UserAvatar user={u} size={22} />
//                                         {u.name}
//                                     </Box>
//                                 </MenuItem>
//                             ))}
//                         </Select>

//                         <Typography sx={fieldLabel}>Reporter</Typography>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <UserAvatar user={USER_BY_ID[task.reporterId]} size={26} />
//                             <Typography sx={{ fontSize: 14 }}>{USER_BY_ID[task.reporterId]?.name}</Typography>
//                         </Box>

//                         <Typography sx={fieldLabel}>Priority</Typography>
//                         <Select
//                             size="small"
//                             value={task.priority}
//                             onChange={(e) => update({ priority: e.target.value as Priority })}
//                             inputProps={{ 'aria-label': 'Priority' }}
//                             sx={{ color: pri.color, fontWeight: 600 }}
//                         >
//                             {(Object.keys(PRIORITIES) as Priority[]).map((p) => {
//                                 const { Icon, color, label } = PRIORITIES[p]
//                                 return (
//                                     <MenuItem key={p} value={p}>
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color }}>
//                                             <Icon fontSize="small" />
//                                             {label}
//                                         </Box>
//                                     </MenuItem>
//                                 )
//                             })}
//                         </Select>

//                         <Typography sx={fieldLabel}>Due date</Typography>
//                         <TextField
//                             size="small"
//                             type="date"
//                             value={task.dueDate ?? ''}
//                             onChange={(e) => e.target.value && update({ dueDate: e.target.value })}
//                             inputProps={{ 'aria-label': `Due date, currently ${formatDueLong(task.dueDate)}` }}
//                             InputLabelProps={{ shrink: true }}
//                         />

//                         <Typography sx={fieldLabel}>Time logged</Typography>
//                         <Typography sx={{ fontSize: 14 }}>{formatMinutes(task.timeSpentMinutes)}</Typography>

//                         {/* <Typography sx={fieldLabel}>Labels</Typography>
//                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
//                             {task.labels.length === 0 && <Typography sx={{ fontSize: 14, color: '#8A8468' }}>None</Typography>}
//                             {task.labels.map((l) => (
//                                 <Chip key={l} size="small" label={l} sx={{ bgcolor: '#ECEADB', color: '#4C4A36', fontWeight: 500, borderRadius: '6px' }} />
//                             ))}
//                         </Box> */}
//                     </Box>

//                     <Box sx={{ pt: 2, borderTop: '1px solid #E2DFD0', fontSize: 12, lineHeight: 1.8, color: '#6B6955' }}>
//                         Created {new Date(task.createdAt).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })} by{' '}
//                         {USER_BY_ID[task.reporterId]?.name}
//                         <br />
//                         Updated {formatWhen(task.updatedAt)}
//                     </Box>
//                 </Box>
//             </DialogContent>

//             {/* Delete confirmation */}
//             <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
//                 <DialogTitle>Delete {task.key}?</DialogTitle>
//                 <DialogContent>
//                     <DialogContentText>This permanently removes the task, its checklist and work log.</DialogContentText>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={() => setConfirmDelete(false)} sx={{ textTransform: 'none', color: '#4F4D33' }}>
//                         Cancel
//                     </Button>
//                     <Button onClick={onDelete} color="error" variant="contained" sx={{ textTransform: 'none', fontWeight: 700 }}>
//                         Delete task
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </Dialog>
//     )
// }
import { useEffect, useState } from 'react'
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    LinearProgress,
    ListItemIcon,
    Menu,
    MenuItem,
    Select,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import AddIcon from '@mui/icons-material/Add'
import ChecklistIcon from '@mui/icons-material/Checklist'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import {
    PRIMARY,
    PRIORITIES,
    STATUSES,
    STATUS_BY_ID,
    USERS,
    USER_BY_ID,
    formatDueLong,
    formatDateTime,
    formatMinutes,
    formatWhen,
    loadActivity,
    type ActivityEntry,
    type Priority,
    type StatusId,
    type TaskPatch,
    type TodoTask,
} from './Tododata.ts'
import UserAvatar from './Useravtar.tsx'
import AssigneeStack from './AssineeStack.tsx'

interface Props {
    task: TodoTask
    labelOptions: string[]
    onClose: () => void
    /** Saved through the API that matches the changed fields. Resolves true only if it saved, so inputs stay open on failure. */
    onUpdate: (patch: TaskPatch) => Promise<boolean> | boolean
    onDelete: () => void
}

const ACTIVITY_PREVIEW = 5

const fieldLabel = { fontSize: 13, color: '#6B6955' } as const
const sectionTitle = { fontSize: 15, fontWeight: 700 } as const
const iconBtn = { border: '1px solid #D5D2BF', borderRadius: '8px', width: 36, height: 36 } as const
const saveBtn = { ...iconBtn, bgcolor: PRIMARY, color: '#fff', borderColor: PRIMARY, '&:hover': { bgcolor: '#5C5A3B' } } as const

export default function TaskDetailDialog({ task, onClose, onUpdate, onDelete }: Props) {
    // Title, description and work log each switch to inputs with their own Save button.
    // Status, assignee, priority, due date and the checklist save as soon as they change.
    const [editTitle, setEditTitle] = useState(false)
    const [titleText, setTitleText] = useState('')
    const [titleError, setTitleError] = useState<string | null>(null)

    const [editDesc, setEditDesc] = useState(false)
    const [descText, setDescText] = useState('')

    const [editLog, setEditLog] = useState(false)
    const [logTime, setLogTime] = useState('')
    const [logNote, setLogNote] = useState('')
    const [logError, setLogError] = useState<string | null>(null)

    const [newItem, setNewItem] = useState('')
    const [newItemAssignee, setNewItemAssignee] = useState('') // '' = unassigned
    const [menuEl, setMenuEl] = useState<HTMLElement | null>(null)
    const [confirmDelete, setConfirmDelete] = useState(false)

    // Assignees: picked in the dropdown, saved once when it closes. null = not editing.
    // assignedTo goes to the API as an array, first person = main assignee.
    const [pendingAssignees, setPendingAssignees] = useState<string[] | null>(null)
    const assigneeIdsNow = pendingAssignees ?? task.assigneeIds
    const saveAssignees = async () => {
        const next = pendingAssignees
        if (!next) return
        const same = [...next].sort().join(',') === [...task.assigneeIds].sort().join(',')
        if (next.length > 0 && !same) await update({ assigneeIds: next })
        setPendingAssignees(null) // on success the task already has the new list; on failure this shows the old one again
    }

    const status = STATUS_BY_ID[task.status]
    const pri = PRIORITIES[task.priority]
    const checklist = task.checklist
    const done = checklist.filter((i) => i.isCompleted).length
    const total = checklist.length

    // --- title ---------------------------------------------------------------
    const startTitle = () => {
        setTitleText(task.title)
        setTitleError(null)
        setEditTitle(true)
    }
    const saveTitle = async () => {
        if (!titleText.trim()) return setTitleError('Task title is required')
        if (titleText.trim() === task.title || (await update({ title: titleText.trim() }))) setEditTitle(false)
    }

    // --- description ---------------------------------------------------------
    const startDesc = () => {
        setDescText(task.description)
        setEditDesc(true)
    }
    const saveDesc = async () => {
        if (descText.trim() === task.description || (await update({ description: descText.trim() }))) setEditDesc(false)
    }

    // --- work log (one time value + one note) ---------------------------------
    const startLog = () => {
        setLogTime(task.timeSpentMinutes ? String(task.timeSpentMinutes) : '')
        setLogNote(task.completionNote ?? '')
        setLogError(null)
        setEditLog(true)
    }
    const saveLog = async () => {
        const n = Number(logTime || 0)
        if (!Number.isInteger(n) || n < 0 || n > 1440) return setLogError('Enter whole minutes, 0 to 1440')
        const note = logNote.trim() || null
        const changed = n !== task.timeSpentMinutes || note !== (task.completionNote ?? null)
        if (!changed || (await update({ timeSpentMinutes: n, completionNote: note }))) setEditLog(false)
    }

    // --- checklist (saved on every change) -----------------------------------
    const toggleItem = (index: number) =>
        update({ checklist: checklist.map((i, n) => (n === index ? { ...i, isCompleted: !i.isCompleted } : i)) })
    const removeItem = (index: number) =>
        update({ checklist: checklist.filter((_, n) => n !== index).map((c, n) => ({ ...c, displayOrder: n + 1 })) })
    const assignItem = (index: number, userId: string) =>
        update({ checklist: checklist.map((i, n) => (n === index ? { ...i, assigneeId: userId || null } : i)) })
    // An item can only be given to someone assigned to the task (plus its current person, so the select never shows blank).
    const taskAssignees = (task.assigneeIds?.length ? task.assigneeIds : [task.assigneeId]).map((id) => USER_BY_ID[id]).filter(Boolean)
    const assigneeOptions = (current?: string | null) =>
        current && USER_BY_ID[current] && !taskAssignees.some((u) => u.id === current) ? [...taskAssignees, USER_BY_ID[current]] : taskAssignees
    const addItem = async () => {
        const text = newItem.trim()
        if (!text) return
        if (await update({ checklist: [...checklist, { isActive: true, displayOrder: checklist.length + 1, itemText: text, isCompleted: false, assigneeId: newItemAssignee || null }] })) {
            setNewItem('')
            setNewItemAssignee('')
        }
    }

    // --- activity (read-only, from the activity API) ---------------------------
    // Loaded when the task opens and again after every successful save, because the server
    // writes an activity row for each change (checklist edits don't change updatedAt, so we can't rely on that).
    const [activity, setActivity] = useState<ActivityEntry[]>([])
    const [activityLoading, setActivityLoading] = useState(true)
    const [showAll, setShowAll] = useState(false)
    const [activityTick, setActivityTick] = useState(0)
    useEffect(() => {
        let cancelled = false
        setActivityLoading(true)
        loadActivity(task.id).then((list) => {
            if (cancelled) return
            setActivity(list)
            setActivityLoading(false)
        })
        return () => {
            cancelled = true
        }
    }, [task.id, task.updatedAt, activityTick])

    /** Save through the parent, then refresh the activity log if it worked. */
    const update = async (patch: TaskPatch) => {
        const ok = await onUpdate(patch)
        if (ok) setActivityTick((t) => t + 1)
        return ok
    }
    const visibleActivity = showAll ? activity : activity.slice(0, ACTIVITY_PREVIEW)

    return (
        <Dialog
            open
            onClose={onClose}
            fullWidth
            maxWidth={false}
            scroll="paper"
            aria-labelledby="task-detail-title"
            PaperProps={{ sx: { width: 1040, maxWidth: '100%', borderRadius: '16px' } }}
        >
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 3, py: 1.5, borderBottom: '1px solid #E2DFD0' }}>
                <Typography sx={{ fontSize: 13, color: '#6B6955' }}>Team tasks</Typography>
                <Typography aria-hidden sx={{ color: '#A09C83' }}>/</Typography>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#55533C' }}>{task.key}</Typography>

                <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton aria-label="More actions" onClick={(e) => setMenuEl(e.currentTarget)} sx={{ border: '1px solid #D5D2BF', borderRadius: '8px' }}>
                        <MoreHorizIcon fontSize="small" />
                    </IconButton>
                    <IconButton aria-label="Close" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Menu anchorEl={menuEl} open={!!menuEl} onClose={() => setMenuEl(null)}>
                    <MenuItem
                        onClick={() => {
                            setMenuEl(null)
                            setConfirmDelete(true)
                        }}
                        sx={{ color: '#B3402F' }}
                    >
                        <ListItemIcon sx={{ color: 'inherit' }}>
                            <DeleteOutlineIcon fontSize="small" />
                        </ListItemIcon>
                        Delete task
                    </MenuItem>
                </Menu>
            </Box>

            <DialogContent sx={{ p: 0, display: 'flex', flexWrap: 'wrap' }}>
                {/* Left: content */}
                <Box sx={{ flex: '999 1 560px', minWidth: 0, p: 3.5, display: 'flex', flexDirection: 'column', gap: 3.5 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        {/* Title */}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                            {editTitle ? (
                                <>
                                    <TextField
                                        fullWidth
                                        autoFocus
                                        label="Title"
                                        value={titleText}
                                        onChange={(e) => setTitleText(e.target.value)}
                                        onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), saveTitle())}
                                        error={!!titleError}
                                        helperText={titleError}
                                    />
                                    <Tooltip title="Save title">
                                        <IconButton aria-label="Save title" onClick={saveTitle} sx={{ ...saveBtn, mt: 1 }}>
                                            <CheckIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <IconButton aria-label="Cancel title edit" onClick={() => setEditTitle(false)} sx={{ ...iconBtn, mt: 1 }}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </>
                            ) : (
                                <>
                                    <Typography id="task-detail-title" component="h1" sx={{ flex: 1, fontSize: 26, fontWeight: 700, lineHeight: 1.3 }}>
                                        {task.title}
                                    </Typography>
                                    <Tooltip title="Edit title">
                                        <IconButton aria-label="Edit title" onClick={startTitle} sx={iconBtn}>
                                            <EditOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}
                        </Box>

                        {/* Description */}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                            {editDesc ? (
                                <>
                                    <TextField
                                        fullWidth
                                        autoFocus
                                        multiline
                                        minRows={3}
                                        label="Description (optional)"
                                        value={descText}
                                        onChange={(e) => setDescText(e.target.value)}
                                    />
                                    <Tooltip title="Save description">
                                        <IconButton aria-label="Save description" onClick={saveDesc} sx={{ ...saveBtn, mt: 1 }}>
                                            <CheckIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <IconButton aria-label="Cancel description edit" onClick={() => setEditDesc(false)} sx={{ ...iconBtn, mt: 1 }}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </>
                            ) : (
                                <>
                                    <Typography sx={{ flex: 1, fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap', color: task.description ? '#55533C' : '#8A8468' }}>
                                        {task.description || 'No description'}
                                    </Typography>
                                    <Tooltip title="Edit description">
                                        <IconButton aria-label="Edit description" onClick={startDesc} sx={iconBtn}>
                                            <EditOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}
                        </Box>
                    </Box>

                    {/* Checklist */}
                    <Box component="section" aria-labelledby="chk">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
                            <ChecklistIcon sx={{ color: '#55533C' }} fontSize="small" />
                            <Typography id="chk" component="h2" sx={sectionTitle}>
                                Checklist
                            </Typography>
                            <Typography sx={{ ml: 'auto', fontSize: 13, fontWeight: 700, color: '#55533C' }}>
                                {done}/{total}
                            </Typography>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={total ? (done / total) * 100 : 0}
                            sx={{ height: 6, borderRadius: 3, bgcolor: '#E6E3D3', '& .MuiLinearProgress-bar': { bgcolor: PRIMARY } }}
                        />
                        <Box sx={{ mt: 1 }}>
                            {checklist.length === 0 && <Typography sx={{ py: 1.5, fontSize: 13, color: '#6B6955' }}>No checklist items yet.</Typography>}
                            {checklist.map((item, index) => (
                                <Box key={item.todoChecklistItemId ?? `new-${index}`} sx={{ display: 'flex', alignItems: 'center', gap: 1, minHeight: 44, borderBottom: '1px solid #EEEBDD' }}>
                                    <Checkbox checked={item.isCompleted} onChange={() => toggleItem(index)} sx={{ '&.Mui-checked': { color: PRIMARY } }} inputProps={{ 'aria-label': item.itemText }} />
                                    <Typography sx={{ flex: 1, fontSize: 14, color: item.isCompleted ? '#6B6955' : '#25241A', fontWeight: item.isCompleted ? 'bold' : 'normal' }}>
                                        {item.itemText}
                                    </Typography>
                                    <Select
                                        size="small"
                                        displayEmpty
                                        value={item.assigneeId ?? ''}
                                        onChange={(e) => assignItem(index, e.target.value as string)}
                                        inputProps={{ 'aria-label': `Assignee for ${item.itemText}` }}
                                        renderValue={(v) => {
                                            const u = v ? USER_BY_ID[v as string] : undefined
                                            return u ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                                    <UserAvatar user={u} size={20} />
                                                    {u.name}
                                                </Box>
                                            ) : (
                                                <Box component="span" sx={{ color: '#8A8468' }}>Unassigned</Box>
                                            )
                                        }}
                                        sx={{ width: 170, fontSize: 13, '& .MuiSelect-select': { py: 0.5 } }}
                                    >
                                        <MenuItem value="">
                                            <em>Unassigned</em>
                                        </MenuItem>
                                        {assigneeOptions(item.assigneeId).map((u) => (
                                            <MenuItem key={u.id} value={u.id}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <UserAvatar user={u} size={20} />
                                                    {u.name}
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <Tooltip title={checklist.length === 1 ? 'A task needs at least one checklist item' : 'Delete item'}>
                                        <span>
                                            <IconButton size="small" aria-label={`Delete ${item.itemText}`} onClick={() => removeItem(index)} disabled={checklist.length === 1}>
                                                <DeleteOutlineIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
                            <TextField
                                size="small"
                                fullWidth
                                placeholder="Add checklist item"
                                value={newItem}
                                onChange={(e) => setNewItem(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addItem())}
                                inputProps={{ 'aria-label': 'Add checklist item' }}
                            />
                            <Select
                                size="small"
                                displayEmpty
                                value={newItemAssignee}
                                onChange={(e) => setNewItemAssignee(e.target.value as string)}
                                inputProps={{ 'aria-label': 'Assignee for the new checklist item' }}
                                renderValue={(v) => {
                                    const u = v ? USER_BY_ID[v as string] : undefined
                                    return u ? (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                            <UserAvatar user={u} size={20} />
                                            {u.name}
                                        </Box>
                                    ) : (
                                        <Box component="span" sx={{ color: '#8A8468' }}>Assign to…</Box>
                                    )
                                }}
                                sx={{ width: 180, fontSize: 13 }}
                            >
                                <MenuItem value="">
                                    <em>Unassigned</em>
                                </MenuItem>
                                {taskAssignees.map((u) => (
                                    <MenuItem key={u.id} value={u.id}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <UserAvatar user={u} size={20} />
                                            {u.name}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                            <IconButton aria-label="Add item" onClick={addItem} disabled={!newItem.trim()} sx={{ border: '1px solid #D5D2BF', borderRadius: '8px', width: 40, height: 40 }}>
                                <AddIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Box>

                    {/* Work log: one time value and one note */}
                    <Box component="section" aria-labelledby="wl" sx={{ p: 2.5, border: '1px solid #E2DFD0', borderRadius: '12px', bgcolor: '#FBFAF5' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.75 }}>
                            <AccessTimeIcon sx={{ color: '#55533C' }} fontSize="small" />
                            <Typography id="wl" component="h2" sx={sectionTitle}>
                                Work log
                            </Typography>
                            <Typography sx={{ ml: 'auto', mr: 0.5, fontSize: 13, fontWeight: 700, color: '#55533C' }}>{formatMinutes(task.timeSpentMinutes)}</Typography>
                            {editLog ? (
                                <>
                                    <Tooltip title="Save work log">
                                        <IconButton aria-label="Save work log" onClick={saveLog} sx={saveBtn}>
                                            <CheckIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <IconButton aria-label="Cancel work log edit" onClick={() => setEditLog(false)} sx={iconBtn}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </>
                            ) : (
                                <Tooltip title="Edit work log">
                                    <IconButton aria-label="Edit work log" onClick={startLog} sx={iconBtn}>
                                        <EditOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                        {editLog ? (
                            <Box sx={{ display: 'flex', alignItems: 'start', flexWrap: 'wrap', gap: 1.5 }}>
                                <TextField
                                    size="small"
                                    type="number"
                                    label="Time spent (minutes)"
                                    value={logTime}
                                    onChange={(e) => setLogTime(e.target.value)}
                                    error={!!logError}
                                    helperText={logError ?? ' '}
                                    inputProps={{ min: 0, max: 1440, step: 5 }}
                                    sx={{ width: 190, '& .MuiOutlinedInput-root': { bgcolor: '#fff' } }}
                                />
                                <TextField
                                    size="small"
                                    label="What was done"
                                    multiline
                                    minRows={2}
                                    value={logNote}
                                    onChange={(e) => setLogNote(e.target.value)}
                                    sx={{ flex: '1 1 280px', '& .MuiOutlinedInput-root': { bgcolor: '#fff' } }}
                                />
                            </Box>
                        ) : task.timeSpentMinutes > 0 || task.completionNote ? (
                            <Typography sx={{ fontSize: 14, color: '#3B3A2A', whiteSpace: 'pre-wrap' }}>
                                <b>{formatMinutes(task.timeSpentMinutes)}</b>
                                {task.completionNote ? `: ${task.completionNote}` : ''}
                            </Typography>
                        ) : (
                            <Typography sx={{ fontSize: 13, color: '#6B6955' }}>No work logged yet.</Typography>
                        )}
                    </Box>

                    {/* Activity */}
                    <Box component="section" aria-labelledby="act">
                        <Typography id="act" component="h2" sx={{ ...sectionTitle, mb: 1.5 }}>
                            Activity
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            {activityLoading && activity.length === 0 && <Typography sx={{ fontSize: 13, color: '#6B6955' }}>Loading activity…</Typography>}
                            {!activityLoading && activity.length === 0 && <Typography sx={{ fontSize: 13, color: '#6B6955' }}>No activity yet.</Typography>}
                            {visibleActivity.map((a) => (
                                <Box key={a.id} sx={{ display: 'flex', gap: 1.5 }}>
                                    <UserAvatar user={USER_BY_ID[a.userId]} size={32} />
                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography sx={{ fontSize: 13 }}>
                                            <b>{USER_BY_ID[a.userId]?.name ?? 'Someone'}</b>{' '}
                                            <Box component="span" sx={{ color: '#6B6955' }}>
                                                · {formatDateTime(a.createdAt)}
                                            </Box>
                                        </Typography>
                                        <Typography sx={{ mt: 0.5, fontSize: 14, lineHeight: 1.5, color: '#3B3A2A', whiteSpace: 'pre-wrap' }}>{a.text}</Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        {activity.length > ACTIVITY_PREVIEW && (
                            <Button
                                size="small"
                                onClick={() => setShowAll((v) => !v)}
                                sx={{ mt: 1.5, textTransform: 'none', fontWeight: 600, color: PRIMARY }}
                            >
                                {showAll ? 'Show latest 5' : `View all (${activity.length})`}
                            </Button>
                        )}
                    </Box>
                </Box>


                {/* Right: details (each change is saved straight away) */}
                <Box
                    component="aside"
                    sx={{ flex: '1 1 300px', maxWidth: { md: 340 }, p: 3, borderLeft: '1px solid #E2DFD0', bgcolor: '#FBFAF5', display: 'flex', flexDirection: 'column', gap: 2.5 }}
                >
                    <Box>
                        <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: '#5F5D48' }}>Status</Typography>
                        <Select
                            fullWidth
                            size="small"
                            value={task.status}
                            onChange={(e) => update({ status: e.target.value as StatusId })}
                            inputProps={{ 'aria-label': 'Status' }}
                            sx={{
                                bgcolor: status?.pillBg,
                                color: status?.ink,
                                fontWeight: 700,
                                '& .MuiOutlinedInput-notchedOutline': { border: 0 },
                                '& .MuiSvgIcon-root': { color: status?.ink },
                            }}
                        >
                            {STATUSES.map((s) => (
                                <MenuItem key={s.id} value={s.id}>
                                    <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: s.dot, mr: 1 }} />
                                    {s.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>

                    <Box>
                        <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: '#5F5D48' }}>Assignees</Typography>
                        <Autocomplete
                            multiple
                            fullWidth
                            disableCloseOnSelect
                            options={USERS}
                            value={assigneeIdsNow.map((id) => USER_BY_ID[id]).filter(Boolean)}
                            onChange={(_, value) => setPendingAssignees(value.map((u) => u.id))}
                            onClose={saveAssignees}
                            getOptionLabel={(u) => u.name}
                            isOptionEqualToValue={(a, b) => a.id === b.id}
                            renderTags={() => null}
                            renderOption={(props, u, { selected }) => (
                                <li {...props} key={u.id} style={{ ...props.style, paddingTop: 8, paddingBottom: 8 }}>
                                    <Checkbox size="small" checked={selected} sx={{ p: 0.5, mr: 1, '&.Mui-checked': { color: PRIMARY } }} />
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
                                        <UserAvatar user={u} size={26} />
                                        <Typography sx={{ fontSize: 14 }}>{u.name}</Typography>
                                    </Box>
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={assigneeIdsNow.length ? `${assigneeIdsNow.length} assigned · search to change` : 'Select people'}
                                    error={assigneeIdsNow.length === 0}
                                    helperText={assigneeIdsNow.length === 0 ? 'Select at least one person' : undefined}
                                    inputProps={{ ...params.inputProps, 'aria-label': 'Assignees' }}
                                    sx={{ bgcolor: '#fff' }}
                                />
                            )}
                        />
                        <Box sx={{ mt: 1.25 }}>
                            <AssigneeStack ids={assigneeIdsNow} size={30} max={7} />
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: 2, alignItems: 'center' }}>
                        <Typography sx={fieldLabel}>Reporter</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <UserAvatar user={USER_BY_ID[task.reporterId]} size={26} />
                            <Typography sx={{ fontSize: 14 }}>{USER_BY_ID[task.reporterId]?.name}</Typography>
                        </Box>

                        <Typography sx={fieldLabel}>Priority</Typography>
                        <Select
                            size="small"
                            value={task.priority}
                            onChange={(e) => update({ priority: e.target.value as Priority })}
                            inputProps={{ 'aria-label': 'Priority' }}
                            sx={{ color: pri.color, fontWeight: 600 }}
                        >
                            {(Object.keys(PRIORITIES) as Priority[]).map((p) => {
                                const { Icon, color, label } = PRIORITIES[p]
                                return (
                                    <MenuItem key={p} value={p}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color }}>
                                            <Icon fontSize="small" />
                                            {label}
                                        </Box>
                                    </MenuItem>
                                )
                            })}
                        </Select>

                        <Typography sx={fieldLabel}>Due date</Typography>
                        <TextField
                            size="small"
                            type="date"
                            value={task.dueDate ?? ''}
                            onChange={(e) => e.target.value && update({ dueDate: e.target.value })}
                            inputProps={{ 'aria-label': `Due date, currently ${formatDueLong(task.dueDate)}` }}
                            InputLabelProps={{ shrink: true }}
                        />

                        <Typography sx={fieldLabel}>Time logged</Typography>
                        <Typography sx={{ fontSize: 14 }}>{formatMinutes(task.timeSpentMinutes)}</Typography>

                        {/* <Typography sx={fieldLabel}>Labels</Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                            {task.labels.length === 0 && <Typography sx={{ fontSize: 14, color: '#8A8468' }}>None</Typography>}
                            {task.labels.map((l) => (
                                <Chip key={l} size="small" label={l} sx={{ bgcolor: '#ECEADB', color: '#4C4A36', fontWeight: 500, borderRadius: '6px' }} />
                            ))}
                        </Box> */}
                    </Box>

                    <Box sx={{ pt: 2, borderTop: '1px solid #E2DFD0', fontSize: 12, lineHeight: 1.8, color: '#6B6955' }}>
                        Created {new Date(task.createdAt).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })} by{' '}
                        {USER_BY_ID[task.reporterId]?.name}
                        <br />
                        Updated {formatWhen(task.updatedAt)}
                    </Box>
                </Box>
            </DialogContent>

            {/* Delete confirmation */}
            <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
                <DialogTitle>Delete {task.key}?</DialogTitle>
                <DialogContent>
                    <DialogContentText>This permanently removes the task, its checklist and work log.</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDelete(false)} sx={{ textTransform: 'none', color: '#4F4D33' }}>
                        Cancel
                    </Button>
                    <Button onClick={onDelete} color="error" variant="contained" sx={{ textTransform: 'none', fontWeight: 700 }}>
                        Delete task
                    </Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    )
}